module.exports = __webpack_public_path__ + "static/media/brand-icons.a046592b.woff";